import { render, staticRenderFns } from "./ProfileBonuses.vue?vue&type=template&id=715ec26e&scoped=true&"
import script from "./ProfileBonuses.js?vue&type=script&lang=js&"
export * from "./ProfileBonuses.js?vue&type=script&lang=js&"
import style0 from "./ProfileBonuses.scss?vue&type=style&index=0&id=715ec26e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ec26e",
  null
  
)

export default component.exports